import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";
import { Body } from "@hypercard/web-components";
import { PresetDateRange, presets } from "./constants";
import { useMemo } from "react";
import { DateRange } from "./types";
import { formatDateRange } from "./utils";
import { Label } from "@/components/ui/label";

// Types
type Props = {
  dateRange: DateRange;
  onChange: (dateRange: DateRange) => void;
  showLabel?: boolean;
};

// Component
export const DateRangePicker = ({
  dateRange,
  onChange,
  showLabel = true,
}: Props) => {
  const displayValue = useMemo(() => {
    const matchingPreset = Object.entries(presets).find(([, value]) => {
      return (
        value.startDate.toISOString() === dateRange.startDate.toISOString() &&
        value.endDate.toISOString() === dateRange.endDate.toISOString()
      );
    });
    if (matchingPreset) {
      return matchingPreset[0] as PresetDateRange;
    } else {
      return formatDateRange(dateRange);
    }
  }, [dateRange]);

  return (
    <div className="space-y-2">
      {showLabel && <Label>Date Range</Label>}
      <Select
        value={displayValue}
        onValueChange={(value) => {
          const dateRange = presets[value as PresetDateRange];
          onChange(dateRange);
        }}
      >
        <SelectTrigger className="min-w-[200px]">
          <Body size="sm" weight="medium">
            {displayValue}
          </Body>
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {Object.entries(presets).map(([key, dateRange]) => (
              <SelectItem key={key} value={key}>
                {/* TODO: implement custom range */}
                {/* {key === PresetDateRange.CustomRange ? (
                <Body size="sm" weight="regular">
                  {key}
                </Body>
              ) : (
                <> */}
                <Body size="sm" weight="regular">
                  {key}
                </Body>
                <Body
                  size="sm"
                  weight="regular"
                  className="mt-0.5 text-xs text-white/50"
                >
                  {formatDateRange(dateRange)}
                </Body>
                {/* </>
              )} */}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};
